module.exports = __webpack_public_path__ + "media/navi/phone_chat-6a5f1f5e.png";